export const couponStepData = [
  {
    id: 1,
    step: '서비스 신청',
    description: '신청서에 원하는 디자인의\n스타일을 입력해주세요.',
  },
  {
    id: 2,
    step: '디자이너 매칭',
    description: '접수 내용을 바탕으로 쿠모가\n디자이너를 매칭해드려요.',
  },
  {
    id: 3,
    step: '디자이너 미팅',
    description: '미팅을 통해 디자인 구체화와\n일정을 조절합니다.',
  },
  {
    id: 4,
    step: '계약 및 결제',
    description:
      '원하는 디자인 시안을 잡은 후,\n 온라인 계약 및 결제를\n진행합니다.',
  },
  {
    id: 5,
    step: '작업 착수',
    description: '신계약/결제 이후에\n 착수에 들어가며,\n 평균 2주 소요됩니다.',
  },
];
